export default {
    indexChargeType: { method: 'get', url: 'emcadmin/charge-types' },
    storeChargeType: { method: 'post', url: 'emcadmin/charge-types' },
    updateChargeType: { method: 'put', url: 'emcadmin/charge-types/{id}'},
    destroyChargeType: { method: 'delete', url: 'emcadmin/charge-types/{id}'},
}